<template>
  <v-card
    class="mx-auto mt-0 subscription-info"
    :loading="isLoading"
    max-width="620"
    min-width="450"
    height="300"
    elevation="2"
  >
    <div
      v-if="!isLoading && !hasError"
      class="d-flex flex-column align-center"
    >
      <div
        class="subStatus font-weight-bold mb-3"
        :style="statusColor"
      >
        Your NoiseAware subscription is {{ subStatus }}
      </div>
      <div class="mb-5">
        {{ paymentMessage }} <span class="font-weight-bold">{{ paymentDate }}</span>
      </div>
      <div
        v-if="!isActive"
        class="mb-8"
      >
        <router-link
          :to="{path: '/billing/edit'}"
          class="billing-link"
        >
          Replace Payment Method
        </router-link>
      </div>
      <!-- Commenting out until we can resolve the .io/.com domain issue
      <div class="more-sensors-link">
        <a
          href="https://checkout.dev.noiseaware.io"
          class="billing-link"
          target="_blank"
        >
          Need more sensors?
        </a>
      </div> -->
    </div>
    <div
      v-else
      class="loader-container d-flex"
    >
      <div class="loading-message">
        <div
          v-if="hasError"
          class="text-center mb-2"
        >
          <v-icon
            v-if="hasError"
            size="24"
            color="error"
          >
            $faExclamationTriangle
          </v-icon>
        </div>
        {{ statusMessage }}
      </div>
    </div>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { DateTime } from 'luxon'
  import { subStatuses } from '@/helpers/billing-helper'

  export default {
    name: 'SubscriptionInfo',
    data () {
      return {
        isLoading: false,
        hasError: false,
      }
    },
    computed: {
      ...mapGetters({
        currentSelectedOrg: 'Permissions/currentSelectedOrg',
        canUpdateBilling: 'Billing/currentOrgBillingEnabled',
        subscription: 'Billing/subscription',
      }),
      isActive () {
        return !this.statusInfo.hasIssue
      },
      statusInfo () {
        return subStatuses[this.subscription.status] || {}
      },
      subStatus () {
        return this.statusInfo.display
      },
      statusColor () {
        return {
          color: this.statusInfo.hasIssue ? '#D16565' : '#476E6C',
        }
      },
      paymentMessage () {
        if (this.statusInfo.hasIssue) {
          return 'Your payment was due on'
        } else {
          return 'Your next payment is scheduled for'
        }
      },
      paymentDate () {
        let billingDate

        if (this.isActive) {
          billingDate = this.subscription.currentPeriodEnd
        } else {
          billingDate = this.subscription.currentPeriodStart
        }

        if (billingDate) {
          const date = new Date(billingDate * 1000)
          return DateTime.fromJSDate(date).toLocaleString(DateTime.DATE_FULL)
        } else {
          return 'unknown'
        }
      },
      statusMessage () {
        if (this.isLoading) {
          return 'Loading subscriptions...'
        } else if (this.hasError) {
          return 'An error occurred while loading your subscriptions.  Please try again later.'
        } else {
          // Should be impossible to get here but just in case...
          return 'An unknown error occurred.  Please reload the page'
        }
      },
    },
    watch: {
      currentSelectedOrg () {
        this.handleOrgUpdate()
      },
    },
    created () {
      this.handleOrgUpdate()
    },
    methods: {
      handleOrgUpdate () {
        if (this.canUpdateBilling) {
          this.getSubscriptionInfo()
        }
      },
      getSubscriptionInfo () {
        this.isLoading = true

        this.$store.dispatch('Billing/getSubscriptions', this.currentSelectedOrg.id)
          .catch(() => {
            this.hasError = true
          })
          .finally(() => {
            this.isLoading = false
          })
      },
    },
  }
</script>
<style lang="scss">
  .subscription-info {
    font-size: 12px;

    .loader-container {
      height: 300px;

      .loading-message {
        margin: auto;
      }
    }

    .subStatus {
      font-size: 18px;
      margin-top: 80px;
    }

    .more-sensors-link {
      position: absolute;
      bottom: 30px;
    }
  }
</style>
